"use strict";

export default class Users {
  constructor($q, API) {
    this.$q = $q;
    this.API = API;
  }

  _getOpts(applicationName) {
    return {
      params: {
        applicationName: applicationName
      }
    };
  }

  getUsers(applicationName) {
    let deferred = this.$q.defer();
    let url = "v1/users";

    this.API.get(url, this._getOpts(applicationName))
      .success((results) => deferred.resolve(results))
      .error((err) => deferred.reject(err));

    return deferred.promise;
  }

  getUserWithGroupInfo(userId) {
    let deferred = this.$q.defer();
    let url = "v1/usersWithGroupInfo/" + userId;

    this.API.get(url)
      .success(function(results){
        deferred.resolve(results);
      })
      .error((err) => deferred.reject(err));

    return deferred.promise;
  }

  createUser(user, applicationName) {

    let deferred = this.$q.defer();
    let url = "v1/users";

    let body = JSON.stringify({
      EmailAddress: user.emailAddress,
      FirstName: user.firstName,
      LastName: user.lastName,
      Enabled: true,
      Role: user.role
    });

    this.API.post(url, body, this._getOpts(applicationName))
      .success((results) => deferred.resolve(results))
      .error((err) => deferred.reject(err));

    return deferred.promise;
  }

  updateUser(user, applicationName) {

    let deferred = this.$q.defer();
    let url = "v1/users/" + user.userId;

    let body = JSON.stringify({
      EmailAddress: user.emailAddress,
      FirstName: user.firstName,
      LastName: user.lastName,
      Role: user.role,
      Enabled: user.enabled
    });

    this.API.put(url, body, this._getOpts(applicationName))
      .success((results) => deferred.resolve(results))
      .error((err) => deferred.reject(err));

    return deferred.promise;
  }

  removeUser(userId, applicationName) {
    let deferred = this.$q.defer();
    let url = "v1/users/" + userId;

    this.API.delete(url, this._getOpts(applicationName))
      .success((results) => deferred.resolve(results))
      .error((err) => deferred.reject(err));

    return deferred.promise;
  }

  setUserVehicleGroups(userId, applicationName, vehicleGroupIds) {
    let deferred = this.$q.defer();
    let url = "v1/users/" + userId + "/vehicle-groups";

    let body = JSON.stringify(vehicleGroupIds);

    this.API.put(url, body, this._getOpts(applicationName))
      .success((results) => deferred.resolve(results))
      .error((err) => deferred.reject(err));

    return deferred.promise;
  }

  setUserDriverGroups(userId, applicationName, driverGroupIds) {
    let deferred = this.$q.defer();
    let url = "v1/users/" + userId + "/driver-groups";
    let body = JSON.stringify(driverGroupIds);

    this.API.put(url, body, this._getOpts(applicationName))
      .success((results) => deferred.resolve(results))
      .error((err) => deferred.reject(err));

    return deferred.promise;
  }

}

Users.$inject = ["$q", "FleetPortalAPI"];



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-fleetlink/fleetlink.user.js